function intersection(a, b) {
  const s = new Set(b);
  return a.filter((x) => s.has(x));
}

function difference(a, b) {
  const s = new Set(b);
  return a.filter((x) => !s.has(x));
}
export {
  intersection,
  difference,
};
